import { motion } from "motion/react";
import { ShieldCheck } from "lucide-react";
import { Eyebrow } from "../components/Buttons";
import { Stagger } from "../components/Reveal";
import CountUp from "../components/CountUp";
import { fadeUp } from "../motion";

export default function WhyChoose() {
  return (
    <section className="why section">
      <div className="container">
        <Stagger as="header" className="why__head">
          <motion.div variants={fadeUp}><Eyebrow>THE NO. 1 DIFFERENCE</Eyebrow></motion.div>
          <motion.h2 variants={fadeUp}>Why choose us</motion.h2>
        </Stagger>
        <Stagger className="why__grid" gap={0.1} amount={0.3}>
          <motion.div className="stat" variants={fadeUp}>
            <div className="stat__num"><CountUp to={100} suffix="%" /></div>
            <div className="stat__label">Satisfaction guaranteed</div>
            <div className="stat__copy">Not happy? We make it right — always.</div>
          </motion.div>
          <motion.div className="stat" variants={fadeUp}>
            <div className="stat__num"><CountUp to={15} suffix="+" duration={1.2} /></div>
            <div className="stat__label">Years in Manly</div>
            <div className="stat__copy">Trusted by locals &amp; tourists since 2009.</div>
          </motion.div>
          <motion.div className="stat" variants={fadeUp}>
            <div className="stat__num"><CountUp to={1} prefix="#" duration={0.6} /></div>
            <div className="stat__label">Premium products</div>
            <div className="stat__copy">World's finest, skin-safe brands only.</div>
          </motion.div>
          <motion.div className="stat" variants={fadeUp}>
            <motion.span className="stat__iconwrap"
              initial={{ scale: 0.6, opacity: 0 }} whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true }} transition={{ type: "spring", stiffness: 260, damping: 14, delay: 0.4 }}>
              <ShieldCheck className="stat__icon" aria-hidden="true" />
            </motion.span>
            <div className="stat__label">Hygiene first</div>
            <div className="stat__copy">Hospital-grade cleanliness, every visit.</div>
          </motion.div>
        </Stagger>
      </div>
    </section>
  );
}
